import { AxiosResponse } from 'axios';
import apiClient from '../axios';
import { Island, IGetIslandsListResponse } from './interfaces';

export const getIslandsList = async (): Promise<Island[]> => {
  const response: AxiosResponse<IGetIslandsListResponse> = await apiClient.get(
    '/islands/list'
  );

  return response.data.data;
};
